import React from 'react'
import { Box, BoxProps, keyframes } from '@mui/material'
import { styled } from '@mui/material/styles'

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.45; }
`

export interface SkeletonProps extends BoxProps {
  width?: number | string
  height?: number | string
  rounded?: 'sm' | 'md' | 'lg' | 'xl' | 'pill'
}

const Root = styled(Box, {
  shouldForwardProp: (p) => p !== '$r',
})<{ $r: string }>(({ $r }) => ({
  backgroundColor: 'var(--ds-hover)',
  borderRadius: $r,
  animation: `${pulse} 1.6s var(--ds-ease) infinite`,
}))

const radiusVar = {
  sm: 'var(--ds-radius-sm)',
  md: 'var(--ds-radius-md)',
  lg: 'var(--ds-radius-lg)',
  xl: 'var(--ds-radius-xl)',
  pill: 'var(--ds-radius-pill)',
}

export function Skeleton({ width = '100%', height = 16, rounded = 'md', ...rest }: SkeletonProps) {
  return <Root $r={radiusVar[rounded]} width={width} height={height} {...rest} />
}
